import { AppLayout } from "@/components/layout";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useListAllGyms } from "@workspace/api-client-react";
import { formatCurrency } from "@/lib/utils";
import { Building2, Search, MapPin, Users, ExternalLink } from "lucide-react";
import { useState } from "react";
import { useLocation } from "wouter";
import { format } from "date-fns";
import { cn } from "@/lib/utils";

export default function SuperadminGyms() {
  const { data: gyms, isLoading } = useListAllGyms();
  const [search, setSearch] = useState("");
  const [, setLocation] = useLocation();

  const filtered = (gyms || []).filter((g: any) =>
    `${g.name} ${g.slug} ${g.city}`.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <AppLayout>
      <div className="flex flex-col gap-8 pb-12">
        <div>
          <h1 className="text-4xl font-display font-bold text-white mb-2">All Gyms</h1>
          <p className="text-muted-foreground">{(gyms || []).length} registered gyms on the platform</p>
        </div>

        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input placeholder="Search gyms..." value={search} onChange={(e) => setSearch(e.target.value)} className="pl-10 bg-background border-white/10" />
        </div>

        {isLoading ? (
          <div className="space-y-4">{[1, 2, 3].map((i) => <div key={i} className="h-24 bg-white/5 rounded-xl animate-pulse" />)}</div>
        ) : filtered.length === 0 ? (
          <div className="p-12 text-center rounded-2xl border border-dashed border-white/10 bg-white/5">
            <Building2 className="w-12 h-12 text-muted-foreground mx-auto mb-4 opacity-50" />
            <p className="text-white font-medium text-lg">No gyms found</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {filtered.map((gym: any) => (
              <Card key={gym.id} className="glass-panel border-white/5 hover:border-primary/30 transition-colors cursor-pointer" onClick={() => setLocation(`/superadmin/gym/${gym.id}`)}>
                <CardContent className="p-5">
                  <div className="flex items-start justify-between">
                    <div>
                      <h3 className="text-xl font-display font-bold text-white">{gym.name}</h3>
                      <p className="text-sm text-muted-foreground flex items-center gap-1 mt-1"><MapPin className="w-3.5 h-3.5" /> {gym.city || "No location"}</p>
                      <div className="flex items-center gap-4 mt-3">
                        <span className={cn(
                          "text-xs px-2 py-0.5 rounded-full font-semibold uppercase",
                          gym.plan === "PREMIUM" ? "bg-primary/20 text-primary" : "bg-white/10 text-muted-foreground"
                        )}>
                          {gym.plan || "FREE"}
                        </span>
                        <span className="text-xs text-muted-foreground font-mono">/{gym.slug}</span>
                      </div>
                    </div>
                    <ExternalLink className="w-4 h-4 text-muted-foreground shrink-0" />
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </AppLayout>
  );
}
